var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "gfu-skip-navigation" },
    [
      _c("base-button", { on: { click: _vm.skipToMainContent } }, [
        _vm._v(
          "\n        " +
            _vm._s(_vm.Resources.Common.SkipToMainContentLabel) +
            "\n    "
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }